import {FIELDS_PATTERN} from 'src/modules/event-create/constants';

const MIN_LENGTH_ATTRIBUTE_DESCRIPTION = 3;
export const MAX_LENGTH_ATTRIBUTE_DESCRIPTION = 255;

export const attributeDescriptionValidation = (attributeDescription: string, id?: number): string[] => {
    const errorMassages = [];
    const matches = attributeDescription.match(FIELDS_PATTERN.description);

    if (attributeDescription.length < MIN_LENGTH_ATTRIBUTE_DESCRIPTION) {
        errorMassages.push(
            `Some of the ${!id ? 'added' : 'update'} attribute has incorrect "Attribute Description".
        "Attribute Description" length must be more than 2 characters`,
        );
    }

    if (matches) {
        errorMassages.push(
            `"${attributeDescription}" incorrect attribute description.
             Use latin alphabet and symbols: . , ( – " ' ) / + - : &`,
        );
    }
    return errorMassages;
};
